var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 59,
    viewBox: "0 0 71 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-732 -534) translate(735 537)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9DCE1",
    fillRule: "nonzero",
    d: "M60.3 37.5H15L10.5 6h55.2c.9 0 1.65.9 1.5 1.8l-5.4 28.5c-.15.75-.75 1.2-1.5 1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 49.5,
    r: 6,
    fill: "#56AAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 49.5,
    r: 6,
    fill: "#56AAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#56AAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M0 0L7.5 0 16.5 46.5 58.5 46.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#097AD0",
    strokeLinecap: "square",
    strokeWidth: 7.5,
    d: "M29.85 10.35L37.2 17.7 48.9 6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCart);
export default __webpack_public_path__ + "static/media/checkout-cart.69282ce1177a9c6fa28db574a92c98cc.svg";
export { ForwardRef as ReactComponent };